<div class="h1 content-title text-center p-3">Civil szervezetek</div>

<div class="content my-3 col-lg-10 mx-auto mx-5">
  <div class="h4 content-title text-center py-3">„HEIMATSKREIS NIKLO”</div>
  <div class="px-5">
    <p>
      Már 1962 óta működik a községben dalkör. Mivel a tagok túlnyomórészt
      idősek utánpótlásra volt szükség. 1992-ben a fiatal lányok kórust
      alkottak, melynek vezetője Hartmann Károlyné. Az évek folyamán a kórus
      hírnévre tett szert nem csak a megyében, de az ország más részein is. A
      2002-es országos minősítő hangversenyen kitűntetésen arany minősítést
      szereztek. Ebből az alkalomból megjelent első CD-jük. Népdalaikat főleg
      helyben gyűjtik, de szívesen tanulnak más forrásokból is dalokat.
      Előadásmódjukban is követik a helyi hagyományokat. A népdalok mellett
      összegyűjtötték a községben még fellelhető egyházi énekeket is. Évente
      német nyelvű májusi litániát és egyházzenei koncertet tartanak, így a
      népdalokon kívül a régi egyházi énekeket is igyekeznek megőrizni. 2006
      januárjában a kórushoz férfi tagok is csatlakoztak, azóta a valamikori
      asszonykórus vegyes kórusként működik. A kórusvezető Hartmann Károlyné,
      harmonikán kísér Hartmann András.
    </p>

    <p>
      Elérhetőség: Székelyi Balázs<br />
      Tel.: 06-30/563-97-05<br />
      E-mail:heimatskreisniklo@gmail.com
    </p>
  </div>
  <div class="h4 content-title text-center py-3">
    DUNASZENTMIKLÓSI TÁNCCSOPORT
  </div>
  <div class="px-5">
    <p>
      1996-ban a fiatalok kezdeményezésére alakult meg a tánccsoport. Ma 22
      fiatal sajátítja el és gyakorolja a magyarországi németek tánckultúráját.
      A művészeti vezető és koreográfus Wenczl József.<br />
      A lányok szintén az ünnepi lányviseletet hordják, a fiúk fekete nadrágot,
      mellényt, fehér inget, csizmát és kalapot viselnek. Több évre
      visszatekintő partnerkapcsolat fűzi őket az Albstadt-ebingeni tánc- és
      népviseleti csoporthoz. Szívesen tanulják meg egymás táncait, ezzel is
      színesítve repertoárjukat.
    </p>

    <p>
      Elérhetőség: Emmer Edina<br />
      Tel.: 30/4243914<br />
      E-mail: edina.emmer@gmail.com
    </p>
  </div>
  <div class="h4 content-title text-center py-3">
    DUNASZENTMIKLÓSI GYERMEK TÁNCCSOPORT
  </div>
  <div class="px-5">
    <p>
      2013-ben alakult a csoport a nagyobbak utánpótlásaként. Jelenleg 15 gyerek
      gyakorolja a magyarországi német táncokat heti egy alkalommal. 2014-ben
      arany minősítést kapott a csoport Balatonberényben, 2015-ben pedig ezüst
      minősítést a Landesrat által szervezett Országos Gyermektánc Fesztiválon.
      Viseletükben ők is a helyi hagyományokat követik, a lányok szintén az
      ünnepi lányviseletet hordják, a fiúk fekete nadrágot, mellényt, fehér
      inget viselnek. Tánccsoport vezetői: Emmer Edina, Nemes Szilvia
    </p>

    <p>
      Elérhetőség: Emmer Edina<br />
      Tel.: 30/4243914<br />
      E-mail: edina.emmer@gmail.com
    </p>
  </div>
  <div class="h4 content-title text-center py-3">DIE LAUSBUBEN ZENEKAR</div>
  <div class="px-5">
    <p>www.lausbuben.hu</p>
  </div>
</div>
